var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loading from '@doordash/component-loading';
import { useIsDynamicBooleanEnabled } from './DynamicValues/hook';
import { fetchPortalData, joinTeamAccounts } from './AppStructure/portal_slice';
import { PortalActions } from '../constants/actions';
import { getPortalData, getStatusForPortalAction, } from '../selectors/portal_selector';
import { ACTIVE_MEMBER_STATUS_STRING, PENDING_MEMBER_STATUS_STRING, DDFW_TERMS_OF_SERVICE_URL, EXTERNAL_ROUTES, IMAGE_BASE_URL, } from '../constants/values';
import FullScreenLayout from './full_screen_layout';
import { FetchStatus, INITIAL_FETCH_STATUS } from '../constants/fetch_status';
import { Colors, Spacing, Text, Stack, StackChildren, } from '@doordash/design-language';
import track from '../utils/track';
import { LoadingContainer, DinovaImage } from './join_page_styles';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import { DYNAMIC_VALUES_NAME } from './DynamicValues';
import { JoinPageEvents } from '../constants/events';
var DINOVA_LOGO_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/myDinova-logo-final.png";
var JOIN_TEAM_ACCOUNTS = PortalActions.JOIN_TEAM_ACCOUNTS;
var ErrorContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  color: red;\n  text-align: center;\n  margin-top: ", "px;\n"], ["\n  font-size: ", "px;\n  color: red;\n  text-align: center;\n  margin-top: ", "px;\n"])), Text.Sizes.S16, Spacing.XSmall);
var Terms = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    font-size: ", "px;\n    color: ", ";\n    margin-top: ", "px;\n    margin-bottom: ", "px;\n  }\n"], ["\n  && {\n    font-size: ", "px;\n    color: ", ";\n    margin-top: ", "px;\n    margin-bottom: ", "px;\n  }\n"])), Text.Sizes.S12, Colors.SystemGrey60, Spacing.XxSmall, Spacing.None);
export var JoinPage = function (props) {
    var _a = __read(React.useState(null), 2), errorMessage = _a[0], setErrorMessage = _a[1];
    React.useEffect(function () {
        if (props.portalData.teamMember.status === PENDING_MEMBER_STATUS_STRING) {
            track(JoinPageEvents.VIEW_JOIN_PAGE_PENDING, {
                email: props.portalData.teamMember.email,
            });
        }
    }, [props.portalData.teamMember.status, props.portalData.teamMember.email]);
    var joinTeamAccountsStatusString = function () {
        return ((props.statusForPortalAction[JOIN_TEAM_ACCOUNTS] &&
            props.statusForPortalAction[JOIN_TEAM_ACCOUNTS].status) ||
            INITIAL_FETCH_STATUS);
    };
    var handleJoin = function () {
        props
            .joinTeamAccounts(props.portalData.teamMember.id)
            .unwrap()
            .then(function () {
            setErrorMessage(null);
            props.fetchPortalData();
        }, function (errorResponse) {
            setErrorMessage(errorResponse.error || 'There was an error.');
        });
    };
    var generateErrorMessage = function () {
        return React.createElement(ErrorContent, null, errorMessage);
    };
    var generatePendingMemberContent = function () {
        var teamName = props.portalData.team.name;
        var isProcessingJoin = joinTeamAccountsStatusString() === FetchStatus.PENDING;
        return (React.createElement("div", null,
            React.createElement("h1", null,
                "Activate your Benefits from ",
                teamName),
            React.createElement(Stack, { size: Stack.Sizes.Medium },
                React.createElement(StackChildren, { size: Stack.Sizes.Medium },
                    React.createElement(Text, null, "By clicking on the button below, you'll join the " + teamName + " team\n              on DoorDash."),
                    React.createElement(Text, null, "You can use any available benefits by placing an order on DoorDash."))),
            React.createElement(Button, { state: isProcessingJoin ? Button.States.Loading : Button.States.Default, size: Button.Sizes.Medium, onClick: handleJoin, isDisabled: isProcessingJoin }, "Activate Benefits"),
            React.createElement(Terms, null,
                "By clicking the button to activate DoorDash for Work on your DoorDash account, you agree to the",
                ' ',
                React.createElement("a", { href: DDFW_TERMS_OF_SERVICE_URL, target: "_blank", rel: "noopener noreferrer" }, "DoorDash for Work terms and conditions"),
                "."),
            errorMessage && generateErrorMessage()));
    };
    var generateDinovaPendingMemberContent = function () {
        var isProcessingJoin = joinTeamAccountsStatusString() === FetchStatus.PENDING;
        return (React.createElement("div", null,
            React.createElement(DinovaImage, { src: DINOVA_LOGO_IMG_URL, alt: "myDinova Rewards" }),
            React.createElement("h1", null, "Start earning points on your DoorDash orders through myDinova Rewards"),
            React.createElement(Stack, { size: Stack.Sizes.Medium },
                React.createElement(StackChildren, { size: Stack.Sizes.Medium },
                    React.createElement(Text, null, "By clicking on the button below, you will be activating your DoorDash for Work account enabling you to earn points on your DoorDash orders. Rewards will be accessible through your myDinova account."))),
            React.createElement(Button, { state: isProcessingJoin ? Button.States.Loading : Button.States.Default, size: Button.Sizes.Medium, onClick: handleJoin, isDisabled: isProcessingJoin }, "Start Earning"),
            React.createElement(Terms, null,
                "By clicking the button to activate DoorDash for Work on your DoorDash account, you agree to the",
                ' ',
                React.createElement("a", { href: DDFW_TERMS_OF_SERVICE_URL, target: "_blank", rel: "noopener noreferrer" }, "DoorDash for Work terms and conditions"),
                "."),
            errorMessage && generateErrorMessage()));
    };
    var generateActiveMemberContent = function () {
        var email = props.portalData.teamMember.email;
        track(JoinPageEvents.VIEW_JOIN_PAGE_SUCCESS, {
            email: email,
        }, {}, function () {
            window.location.href = EXTERNAL_ROUTES.BENEFITS_PAGE + "?join=true";
        });
        return (React.createElement(LoadingContainer, null,
            React.createElement(Loading, { size: Loading.Sizes.XLarge })));
    };
    var status = props.portalData.teamMember.status;
    var isDinovaRewardsEnabled = useIsDynamicBooleanEnabled(DYNAMIC_VALUES_NAME.ddfwDinovaRewardsEnabled);
    return (React.createElement(FullScreenLayout, null, status === ACTIVE_MEMBER_STATUS_STRING
        ? generateActiveMemberContent()
        : isDinovaRewardsEnabled
            ? generateDinovaPendingMemberContent()
            : generatePendingMemberContent()));
};
var mapStateToProps = function (state) { return ({
    portalData: getPortalData(state),
    statusForPortalAction: getStatusForPortalAction(state),
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        fetchPortalData: fetchPortalData,
        joinTeamAccounts: joinTeamAccounts,
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(JoinPage);
var templateObject_1, templateObject_2;
